export default __webpack_public_path__ + "static/media/plus.bbcf869d.svg";